import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import Api from '@/apis/api';

Vue.use(VueRouter);

const notLoggedIn = () => (form, to, next) => {
  if (store.state.user.accessToken) {
    next('/user');
  }
  next();
};

const routes = [
  {
    path: '/',
    name: 'Login',
    beforeEnter: notLoggedIn(),
    component: () => import('@/views/login/Login'),
    meta: { unauthorized: true },
  },
  {
    path: '/initial',
    component: () => import('@/views/Main.vue'),
    children: [{ path: '', component: () => import('@/views/login/InitialPwdSetting') }],
  },
  {
    path: '/user',
    component: () => import('@/views/Main.vue'),
    children: [
      { path: '', component: () => import('@/views/user/List') },
      { path: 'register', component: () => import('@/views/user/Register') },
      { path: 'modify/:id', component: () => import('@/views/user/Register') },
      { path: 'status/:id', component: () => import('@/views/user/OralStatus') },
      { path: 'tooth/:id', component: () => import('@/views/user/Tooth') },
    ],
  },
  {
    path: '/status/page',
    name: 'NewPage',
    component: () => import('@/views/user/UserReportPopupPage'),
    beforeEnter: (to, from, next) => {
      if (to.query.id && to.query.day) next();
      else next('/user');
    },
  },
  {
    path: '/admin',
    component: () => import('@/views/Main.vue'),
    children: [
      { path: '', component: () => import('@/views/admin/List') },
      { path: 'register', component: () => import('@/views/admin/Register') },
    ],
  },
  {
    path: '/statistics',
    component: () => import('@/views/Main.vue'),
    children: [
      {
        path: '',
        redirect: 'period',
        component: () => import('@/views/statistics/Statistics'),
        children: [
          { path: 'period', component: () => import('@/views/statistics/PeriodStatistics') },
          { path: 'oral', component: () => import('@/views/statistics/OralStatistics') },
        ],
      },
    ],
  },
  {
    path: '/app/terms',
    component: () => import('@/views/app/Terms.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/app/info',
    component: () => import('@/views/app/Info.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/app/marketing',
    component: () => import('@/views/app/Marketing.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/app/service-analysis',
    component: () => import('@/views/app/ServiceAnalysis.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/app/test-analysis',
    component: () => import('@/views/app/TestAnalysis.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/app/medical-reference',
    component: () => import('@/views/app/MedicalReference.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/app/rating-criteria',
    component: () => import('@/views/app/RatingCriteria.vue'),
    meta: { unauthorized: true },
  },
  {
    path: '/404',
    component: () => import('@/views/Main.vue'),
    children: [{ path: '', component: () => import('@/views/NotFound') }],
  },
  {
    path: '*',
    redirect: '/404',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // 로그인 이후 새로고침 시
  if (!store.state.user.accessToken && localStorage.getItem('accessToken')) {
    const res = await Api.updateInfo();
    // res.data : 서버 통신 성공
    if (res && res.data) {
      // res.data.rt === 200 : 통신 이후 정상 상태 확인 성공
      if (res.data.rt === 200) {
        // 유저 정보 업데이트
        store.dispatch('user/updateInfo', res.data.loginInfo);
      } else {
        alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ' + res.data.rt);
      }
    } else {
      // 서버 통신 실패 시 정상 페이지 이동, 해당 페이지 내 API 통신에서 서버 오류 alert
      return next();
    }
  }

  // 인증이 필요한 페이지에서 토큰이 없는 경우 로그인 페이지로 이동
  if (!to.matched.some(record => record.meta.unauthorized) && !store.state.user.accessToken) {
    return next('/');
  }

  next();
});

export default router;
